import NAVIGATION_MENU, {
	type NavigationMenuDestination,
	type NavigationMenuEntry,
	type NavigationMenuSection,
} from '@UI/Routing/navigationMenu';

export type ActiveNavigation = {
	readonly section: NavigationMenuSection;
	readonly entry: NavigationMenuEntry;
	readonly destination: NavigationMenuDestination;
};

const matchesPath = (destinationPath: string, pathname: string): boolean => {
	return pathname === destinationPath || pathname.startsWith(`${destinationPath}/`);
};

/** Longest destination path that equals `pathname` or prefixes it followed by `/`; `null` if none. */
const resolveActiveNavigation = (
	pathname: string,
	menu: readonly NavigationMenuSection[] = NAVIGATION_MENU,
): ActiveNavigation | null => {
	let best: ActiveNavigation | null = null;

	for (const section of menu) {
		for (const entry of section.entries) {
			for (const destination of entry.destinations) {
				const isLonger = best === null || destination.path.length > best.destination.path.length;

				if (isLonger && matchesPath(destination.path, pathname)) {
					best = { section, entry, destination };
				}
			}
		}
	}

	return best;
};

export default resolveActiveNavigation;
